import React from "react";
import { useTranslation } from "react-i18next";

const Eyebrow = ({ children }) => {
  const commentText = "//";
  return (
    <div className="eyebrow" aria-hidden>
      <span>{commentText}</span> {children}
    </div>
  );
};

function WerkwijzeSection() {
  const { t, i18n } = useTranslation();
  
  // Determine which assets to use based on language
  const isEnglish = i18n.language === 'en';
  const imageFile = isEnglish ? 'wwEN.png' : 'werkwijze.png';
  const pdfFile = isEnglish ? 'werkwijzeEN.pdf' : 'Werkwijze.pdf';
  
  return (
    <section id="werkwijze" className="card werkwijze">
      <div className="werkwijze__header">
        <Eyebrow>{t('werkwijze.eyebrow')}</Eyebrow>
        <h3 className="werkwijze__title">{t('werkwijze.title')}</h3>
      </div>

      <div className="werkwijze-preview">
        <div className="werkwijze-preview__image">
          <img 
            src={`${process.env.PUBLIC_URL}/assets/${imageFile}`} 
            alt={t('werkwijze.documentTitle')}
            className="werkwijze-preview__img"
          />
        </div>
        <div className="werkwijze-preview__footer">
          <div className="werkwijze-preview__meta">
            <div className="werkwijze-preview__title">{t('werkwijze.documentTitle')}</div>
            <div className="werkwijze-preview__pages">2 {t('werkwijze.pages')}</div>
          </div>
          <div className="werkwijze-preview__actions">
            <a 
              href={`${process.env.PUBLIC_URL}/assets/${pdfFile}`} 
              className="btn" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              {t('werkwijze.open')}
            </a>
            <a 
              href={`${process.env.PUBLIC_URL}/assets/${pdfFile}`} 
              className="btn btn--primary" 
              download
            >
              {t('werkwijze.download')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WerkwijzeSection;
